import { render, staticRenderFns } from "./BPCarsoule.vue?vue&type=template&id=2a4f5157&scoped=true&"
import script from "./BPCarsoule.vue?vue&type=script&lang=js&"
export * from "./BPCarsoule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f5157",
  null
  
)

export default component.exports